"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Erc20Token2 = _interopRequireDefault(require("./Erc20Token"));

var _Currency = require("../Currency");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var WethToken = /*#__PURE__*/function (_Erc20Token) {
  (0, _inherits2["default"])(WethToken, _Erc20Token);

  var _super = _createSuper(WethToken);

  function WethToken(contract, web3Service, decimals) {
    (0, _classCallCheck2["default"])(this, WethToken);
    return _super.call(this, contract, web3Service, decimals, 'WETH');
  }

  (0, _createClass2["default"])(WethToken, [{
    key: "name",
    value: function name() {
      return this._contract.name();
    }
  }, {
    key: "deposit",
    value: function deposit(amount) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$unit = _ref.unit,
          unit = _ref$unit === void 0 ? _Currency.ETH : _ref$unit,
          options = (0, _objectWithoutProperties2["default"])(_ref, ["unit"]);

      return this._contract.deposit(_objectSpread({
        value: this._valueForContract(amount, unit)
      }, options));
    }
  }, {
    key: "withdraw",
    value: function withdraw(amount) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$unit = _ref2.unit,
          unit = _ref2$unit === void 0 ? _Currency.WETH : _ref2$unit,
          options = (0, _objectWithoutProperties2["default"])(_ref2, ["unit"]);

      var value = this._valueForContract(amount, unit);

      return this._contract.withdraw(value, options);
    }
  }]);
  return WethToken;
}(_Erc20Token2["default"]);

exports["default"] = WethToken;